<template>
    <header class="calendar-filters" v-show="showMainHeader">
        <div class="left-filters">
            <div class="filter">
                <span class="fw-bold pb-1 label">Organization</span>
                <MultiSelect
                    classes="first-btn"
                    :dropDownOptions="agencyMultiSelectOptions"
                    labelText="Organizations"
                    :selectedOptions="selectedAgencies"
                    v-on:updateBranches="updateBranches"
                />
            </div>
            <div class="filter">
                <span class="fw-bold pb-1 label">Branches</span>
                <BranchDefaultFilter
                    classes="first-btn"
                    :check-all-by-default="true"
                    :isCalendar="true"
                    :selected-branches="selectedBranches"
                    v-on:updateBranches="handleBranchesOnChange"
                    :selected-agencies-name="selectedAgenciesName"
                />
            </div>
            <div class="filter" v-if="!isEmployeeCalendar">
                <span class="fw-bold pb-1 label">Case Manager</span>
                <MultiSelectFilter
                   classes="first-btn"
                   :on-fetch= "caseManagerFetch"
                   :selectedItems="selectedCaseManagers"
                   v-on:selectedItemsUpdated="selectedCaseManagersUpdated"
                   :custom-message="'Select Case Manager'"
                   placeholder="Search Case Managers"

                />
            </div>
            <div class="filter" v-if="isEmployeeCalendar">
                <span class="fw-bold pb-1 label">Credentials</span>
                <MultiSelectFilter
                    classes="first-btn"
                    :on-fetch="userCredentialsFetch"
                    :selectedItems="selectedCredentials"
                    v-on:selectedItemsUpdated="selectedItemsUpdated"
                    name="User Credentials"
                />
            </div>
            <div class="filter" v-if="isPatientCalendar && listView !== CalendarViewTypeEnum.Map">
                <span class="fw-bold pb-1 label">Schedule</span>
                <select
                    class="form-select px-2 first-btn"
                    name="weekday-range"
                    v-model="scheduleFilter"
                    @change="handleScheduleChange"
                >
                    <option
                        v-for="[key, value] in enumToMap(PatientScheduledFilterEnums)"
                        :value="value.value"
                        :key="key"
                    >
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div class="filter" v-if="isPatientCalendar">
                <div class="fw-bold pb-1 label">Status</div>
                <select
                    class="form-select pl-1 first-btn"
                    name="patient-status"
                    v-model="selectedPatientStatus"
                    @change="handlePatientStatusChange"
                >
                    <option :value="null">All</option>
                    <option v-for="item of patientStatusEnums" :value="item.value" :key="item.value">
                        {{ item.name }}
                    </option>
                </select>
            </div>
            <div class="filter" v-if="isEmployeeCalendar">
                <span class="fw-bold pb-1 label">User Titles</span>
                <MultiSelectFilter
                    classes="first-btn"
                    :on-fetch="userTitlesFetch"
                    :selectedItems="selectedTitles"
                    v-on:selectedItemsUpdated="selectedTitlesUpdated"
                    name="User Titles"
                />
            </div>
            <div class="filter" v-if="isEmployeeCalendar && listView !== CalendarViewTypeEnum.Map">
                <span class="fw-bold pb-1 label">Schedule</span>
                <select
                    class="form-select px-2 first-btn schedule"
                    name="weekday-range"
                    v-model="scheduleFilter"
                    @change="handleScheduleChange"
                >
                    <option v-for="[key, value] in enumToMap(ScheduledFilterEnums)" :value="value.value" :key="key">
                        {{ value.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="right-filters">
            <div class="top">
                <div id="employee-search" class="filter search-employee mb-2 my-lg-auto">
                    <MultiSelectFilter
                        v-if="isEmployeeCalendar"
                        :on-fetch="fetchEmployeeList"
                        :selectedItems="selectedEmployeesSearch"
                        v-on:selectedItemsUpdated="selectedEmployeesSearchUpdated"
                        :placeholder="`Search by Employees Name`"
                        name="Employees"
                        :isCalendar="true"
                    />

                    <div v-else class="input-group patient-search">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Search for Patient by Name"
                            v-model="term"
                        />
                        <div class="input-group-append">
                            <div class="input-group-text">
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter">
                    <div class="list-view-btn" v-if="hasTestAgency">
                        <button
                            :class="`btn weekly-view ${
                                listView == CalendarViewTypeEnum.Weekly || listView == CalendarViewTypeEnum.Daily
                                    ? 'active'
                                    : ''
                            }`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                        >
                            Calendar
                        </button>

                        <button
                            :class="`btn map-view${isEmployeeCalendar ? '-emp' : ''} ${listView == CalendarViewTypeEnum.Map ? 'active' : ''}`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Map)"
                        >
                            Map
                        </button>
                        <button
                            v-if="isEmployeeCalendar"
                            :class="`btn summary-view ${listView == CalendarViewTypeEnum.SummaryView ? 'active' : ''}`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.SummaryView)"
                        >
                            Summary
                        </button>
                    </div>
                    <div class="list-view-btn" v-else>
                        <button
                            :class="`btn weekly-view ${
                                listView == CalendarViewTypeEnum.Weekly || listView == CalendarViewTypeEnum.Daily
                                    ? 'active'
                                    : ''
                            }`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                        >
                            Calendar
                        </button>

                        <button
                            :class="`btn map-view ${listView == CalendarViewTypeEnum.Map ? 'active' : ''}`"
                            @click="() => handleViewChange(CalendarViewTypeEnum.Map)"
                        >
                            Map
                        </button>
                    </div>
                </div>
            </div>
            <div
                :class="`bottom ${listView == CalendarViewTypeEnum.Daily ? 'daily' : ''} ${isPatientCalendar ? 'isPatient' : ''}`"
            >
                <div class="weekly-filter">
                    <div class="filter" v-if="isEmployeeCalendar && listView !== CalendarViewTypeEnum.SummaryView">
                        <div class="list-view-btn-weekly">
                            <button
                                :class="`btn weekly-view ${listView == CalendarViewTypeEnum.Weekly ? 'active' : ''}`"
                                @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                            >
                                Weekly
                            </button>
                            <button
                                :class="`btn daily-view ${listView == CalendarViewTypeEnum.Daily ? 'active' : ''}`"
                                @click="() => handleViewChange(CalendarViewTypeEnum.Daily)"
                            >
                                Daily
                            </button>
                        </div>
                    </div>
                    <div
                        class="filter ms-0 ms-md-4 week-range"
                        v-if="
                            (listView === CalendarViewTypeEnum.Weekly ||
                                listView === CalendarViewTypeEnum.SummaryView) &&
                            (isEmployeeCalendar || isPatientCalendar)
                        "
                    >
                        <select
                            id="weekday_range"
                            class="form-select pl-1"
                            name="weekday-range"
                            v-model="selectedWeekdayRange"
                        >
                            <option v-for="item of weekDayRangeEnums" :value="item.value" :key="item.value">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="date-navigate">
                    <WeeklyDateNavigation
                        v-if="listView === CalendarViewTypeEnum.Weekly || listView === CalendarViewTypeEnum.SummaryView"
                        :startDate="startDate"
                        :endDate="endDate"
                        v-on:taskRefresh="updateDateRange"
                    />
                    <DailyDateNavigation
                        v-if="listView === CalendarViewTypeEnum.Daily && isEmployeeCalendar"
                        :startDate="dailyDate"
                        :endDate="dailyDate"
                        v-on:taskRefresh="dailyDateUpdate"
                    />
                </div>
                <!-- dont remove this added to fix styling -->
                <div class="other"></div>
            </div>
        </div>
    </header>
    <header v-show="!showMainHeader" class="header-two">
        <div class="left-two-filters">
            <div class="dropdown filters-dropdown">
                <button
                    type="button dropdown-toggle"
                    class="btn border filter-popup-btn"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-bs-auto-close="outside"
                >
                    Filters <i class="fas fa-ellipsis-h cursor-pointer"></i>
                </button>
                <div class="dropdown-menu filter-menu" ref="dropdownEle">
                    <div class="filter">
                        <span class="fw-bold pb-1 label">Organization</span>
                        <MultiSelect
                            classes="first-btn"
                            :dropDownOptions="agencyMultiSelectOptions"
                            labelText="Organizations"
                            :selectedOptions="selectedAgencies"
                            v-on:updateBranches="updateBranches"
                        />
                    </div>
                    <div class="filter">
                        <span class="fw-bold pb-1 label">Branches</span>
                        <BranchDefaultFilter
                            classes="first-btn"
                            :check-all-by-default="true"
                            :isCalendar="true"
                            :selected-branches="selectedBranches"
                            v-on:updateBranches="handleBranchesOnChange"
                            :selected-agencies-name="selectedAgenciesName"
                        />
                    </div>
                    <div class="filter" v-if="isEmployeeCalendar">
                        <span class="fw-bold pb-1 label">Credentials</span>
                        <MultiSelectFilter
                            classes="first-btn"
                            :on-fetch="userCredentialsFetch"
                            :selectedItems="selectedCredentials"
                            v-on:selectedItemsUpdated="selectedItemsUpdated"
                            name="User Credentials"
                        />
                    </div>
                    <div class="filter" v-if="isEmployeeCalendar && listView !== CalendarViewTypeEnum.Map">
                        <span class="fw-bold pb-1 label">Schedule</span>
                        <select
                            class="form-select px-2 first-btn"
                            name="weekday-range"
                            v-model="scheduleFilter"
                            style="width: 170px"
                            @change="handleScheduleChange"
                        >
                            <option
                                v-for="[key, value] in enumToMap(ScheduledFilterEnums)"
                                :value="value.value"
                                :key="key"
                            >
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div class="filter" v-if="isPatientCalendar && listView !== CalendarViewTypeEnum.Map">
                        <span class="fw-bold pb-1 label">Schedule</span>
                        <select
                            class="form-select px-2 first-btn"
                            name="weekday-range"
                            v-model="scheduleFilter"
                            @change="handleScheduleChange"
                        >
                            <option
                                v-for="[key, value] in enumToMap(PatientScheduledFilterEnums)"
                                :value="value.value"
                                :key="key"
                            >
                                {{ value.name }}
                            </option>
                        </select>
                    </div>
                    <div class="filter" v-if="isPatientCalendar">
                        <div class="fw-bold pb-1 label">Status</div>
                        <select
                            class="form-select pl-1 first-btn"
                            name="patient-status"
                            v-model="selectedPatientStatus"
                            @change="handlePatientStatusChange"
                        >
                            <option :value="null">All</option>
                            <option v-for="item of patientStatusEnums" :value="item.value" :key="item.value">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-two-filters">
            <div id="employee-search" class="filter search-employee">
                <MultiSelectFilter
                    v-if="isEmployeeCalendar"
                    :on-fetch="fetchEmployeeList"
                    :selectedItems="selectedEmployeesSearch"
                    v-on:selectedItemsUpdated="selectedEmployeesSearchUpdated"
                    :placeholder="`Search by Employees Name`"
                    name="Employees"
                    :isCalendar="true"
                />

                <div v-else class="input-group" style="width: 35rem">
                    <input type="text" class="form-control" placeholder="Search for Patient by Name" v-model="term" />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <i class="fas fa-search"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="filter me-2">
                <div class="list-view-btn" v-if="hasTestAgency">
                    <button
                        :class="`btn weekly-view ${
                            listView == CalendarViewTypeEnum.Weekly || listView == CalendarViewTypeEnum.Daily
                                ? 'active'
                                : ''
                        }`"
                        @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                    >
                        Calendar
                    </button>

                    <button
                        :class="`btn map-view${isEmployeeCalendar ? '-emp' : ''} ${listView == CalendarViewTypeEnum.Map ? 'active' : ''}`"
                        @click="() => handleViewChange(CalendarViewTypeEnum.Map)"
                    >
                        Map
                    </button>
                    <button
                        v-if="isEmployeeCalendar"
                        :class="`btn summary-view ${listView == CalendarViewTypeEnum.SummaryView ? 'active' : ''}`"
                        @click="() => handleViewChange(CalendarViewTypeEnum.SummaryView)"
                    >
                        Summary
                    </button>
                </div>
                <div class="list-view-btn" v-else>
                    <button
                        :class="`btn weekly-view ${
                            listView == CalendarViewTypeEnum.Weekly || listView == CalendarViewTypeEnum.Daily
                                ? 'active'
                                : ''
                        }`"
                        @click="() => handleViewChange(CalendarViewTypeEnum.Weekly)"
                    >
                        Calendar
                    </button>

                    <button
                        :class="`btn map-view ${listView == CalendarViewTypeEnum.Map ? 'active' : ''}`"
                        @click="() => handleViewChange(CalendarViewTypeEnum.Map)"
                    >
                        Map
                    </button>
                </div>
            </div>
        </div>
    </header>
</template>

<style src="./CalendarFilters.scss"></style>
<script src="./CalendarFilters.ts"></script>
